import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useBackerApi } from '../../api';
import { backerKeys } from '../../query-key-factory';
import { ConsumerBacker } from '../backer/backer.types';
import { ConsumerFamily, ConsumerFamilyChild } from './families.types';

const useUpdateConsumerFamily = () => {
  const BackerApi = useBackerApi();
  const queryClient = useQueryClient();

  const updateConsumerFamily = async ({ familyId, name }: { familyId: string; name: string }) => {
    const { data } = await BackerApi.put<{ family: ConsumerFamily }>(
      `/consumer/families/${familyId}`,
      {
        family: { name },
      }
    );
    return data;
  };
  return useMutation({
    mutationFn: updateConsumerFamily,
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: backerKeys.consumer.families.all,
      });
    },
  });
};

const useUpdateConsumerFamilyBacker = () => {
  const BackerApi = useBackerApi();
  const queryClient = useQueryClient();

  const updateConsumerFamilyBacker = async ({
    familyId,
    backerId,
    backer,
  }: {
    familyId: string;
    backerId: string;
    backer: Partial<ConsumerBacker>;
  }) => {
    const { data } = await BackerApi.put<{ family: ConsumerFamily }>(
      `/consumer/families/${familyId}/backers/${backerId}`,
      {
        backer,
      }
    );
    return data;
  };
  return useMutation({
    mutationFn: updateConsumerFamilyBacker,
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: backerKeys.consumer.families.all,
      });
    },
  });
};

const useUpdateConsumerFamilyChild = () => {
  const BackerApi = useBackerApi();
  const queryClient = useQueryClient();

  const updateConsumerFamilyChild = async ({
    familyId,
    childId,
    child,
  }: {
    familyId: string;
    childId: string;
    child: Partial<ConsumerFamilyChild>;
  }) => {
    const { data } = await BackerApi.put<{ family: ConsumerFamily }>(
      `/consumer/families/${familyId}/children/${childId}`,
      {
        child,
      }
    );
    return data;
  };
  return useMutation({
    mutationFn: updateConsumerFamilyChild,
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: backerKeys.consumer.families.all,
      });
    },
  });
};
export { useUpdateConsumerFamily, useUpdateConsumerFamilyBacker, useUpdateConsumerFamilyChild };
